<ion-app class="dark-theme">
  <app-menu [showMenu]="!!userInfo" [userInfo]="userInfo"></app-menu>
</ion-app>
<!-- <img class="logo" *ngIf="showMenu" src="./assets/img/logo-iguana-portal-izquierda.png" alt="Logo" > -->

<app-loading></app-loading>
